import { ReactNode } from 'react'
import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
import UserPool from '../pages/auth/UserPool'

/**
 * Props for the GuestGuard component.
 * @typedef {Object} GuestGuardProps
 * @property {ReactNode} children - The child components to render if no user is logged in.
 */
interface GuestGuardProps {
    children: ReactNode
}
/**
 * A guard component that restricts authenticated users from accessing certain routes.
 * If a user is logged in, they will be redirected to the home page (`'/'`).
 *
 * @param {GuestGuardProps} props - The component props.
 * @returns {JSX.Element} The child components if no user is logged in, otherwise redirects to home.
 */
GuestGuard.propTypes = {
    children: PropTypes.node.isRequired
}

export default function GuestGuard({ children }: GuestGuardProps) {
    const currentUser = UserPool.getCurrentUser()

    if (currentUser) {
        return <Navigate to={'/'} />
    }

    return <>{children}</>
}
